import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/')({
  component: SettingsIndex,
});

function SettingsIndex() {
  return <Navigate to="/settings/account" replace />;
}
